import request from './../../../utils/request/index';
import APIS from './../../../const/apis';

const actions = {
  updateCampaignStatus(params) {
    return request.postForm(APIS.campaign.status, params);
  },
  getCampaignList(params) {
    return request.post(APIS.campaign.list, params);
  },
  getCampaignDailyData(params) {
    return request.get(APIS.campaign.daily, params);
  },
  getCampaignDetails(params) {
    return request.get(APIS.campaign.campaignDetail, params);
  },
};
export default actions;
